module.exports = __webpack_public_path__ + "img/freek_05.dc52895e.jpg";